import BaseActionTypes from "../../base/BaseActionTypes";

const RESOURCE = "Spaces";

const SpacesActionTypes = {
  ...BaseActionTypes(RESOURCE),
};

export default SpacesActionTypes;
